import React, { CSSProperties, MouseEventHandler } from "react";
import { Button } from "antd";
import "./HeaderButton.less";

type Props = {
  label: string;
  className?: string;
  styles?: CSSProperties;
  children?: React.ReactNode;
  path?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onContextMenu?: MouseEventHandler<HTMLButtonElement>;
};

const HeaderButton: React.FC<Props> = ({
  label,
  className,
  styles,
  children,
  path,
  onClick,
  onContextMenu,
}) => {
  const navigateOnClick = () => {
    if (path)
      window.open(path, '_blank');
  }

  return (
    <Button className={className} style={styles} onClick={onClick || navigateOnClick} onContextMenu={onContextMenu}>
      {label}
      {children}
    </Button>
  );
};

export default HeaderButton;
